import { createContext } from 'react';

import type { ComposerContextValue } from 'src/pages/landlord/leads/messages/context/composer-types';

export const ComposerContext = createContext<ComposerContextValue | undefined>(undefined);
